<template>
  <el-menu :collapse-transition="true" :default-active="activeIndex" :router="true" @select="handleSelect"
           active-text-color="#1d3752" background-color="#fff" class="esb-header" menu-trigger="hover" style="font-family: Verdana;font-size: 10pt;"
           mode="horizontal" text-color="#fff">

    <el-menu-item @click="menuOpenToggle" class="icon-container float-left">
      <i class="el-icon-arrow-left icon"></i>
    </el-menu-item>

    <el-menu-item @click="openPage('/cpanel/user/active/profile')" class="icon-container float-left">
      <i class="el-icon-user-solid icon"></i>Profile
    </el-menu-item>

    <el-menu-item @click="openPage('/cpanel/dashboard')" class="icon-container float-left">
      <i class="el-icon-menu icon"></i>Dashboard
    </el-menu-item>

    <el-menu-item index="/cpanel/User/logout" class="icon-container">
      <i class="el-icon-switch-button icon" style="color: #f17214;"></i>{{ $ml.get('logout') }}
    </el-menu-item>

    <el-menu-item  class="icon-container" @click="openInfoDialog">
        <i class="el-icon-info icon"></i>Info
    </el-menu-item>

    <el-menu-item  class="icon-container m-0"  @click="openNotificationsDialogVisibility" v-if="newNotificationsCount == 0">
      <i class="el-icon-bell icon"></i>{{newNotificationsCount}}
    </el-menu-item>
    <el-menu-item  class="icon-container bg-light-gray" @click="openNotificationsDialogVisibility" v-else>
      <i class="el-icon-bell icon"></i>{{newNotificationsCount}}
    </el-menu-item>

    <voipResellerHeader v-if="userProfileId == 5" :userVOSBalance="userVOSBalance" :userVOSOverdraft="userVOSOverdraft"></voipResellerHeader>
    <voipCustomerHeader v-if="userProfileId == 6" :userVOSBalance="userVOSBalance" :userVOSOverdraft="userVOSOverdraft" :todayconsumption="userVOSTodayconsumption"></voipCustomerHeader>
    <voipGenerateLiveUserHeader v-if="userProfileId == 12" :userVOSBalance="userVOSBalance" :userVOSOverdraft="userVOSOverdraft" :todayconsumption="userVOSTodayconsumption"></voipGenerateLiveUserHeader>

    <el-dialog :visible.sync="notificationsDialogVisibility" title="Notifications" top="5vh" width="800px">
      <el-button style="position: absolute;right: 20px;top: 20px;" type="danger" size="small" @click="clearAllUserNotification">Clear All</el-button>
      <div class="p-3">
        <el-table
            height="500px"
            :row-class-name="tableRowClassName"
            :data="userNotifications"
            style="width: 100%">
          <el-table-column
              label="Title"
              prop="title"
              width="150">
          </el-table-column>
          <el-table-column
              label="Message"
              prop="message">
            <template slot-scope="scope">
              <span v-html="scope.row.message"></span>
            </template>
          </el-table-column>
          <el-table-column
              label="Date"
              prop="date"
              width="130">
          </el-table-column>
          <!--<el-table-column
              label="Status"
              width="100"
              prop="status">
            <template slot-scope="scope">
              <span v-html="scope.row.status"></span>
            </template>
          </el-table-column>-->
          <el-table-column
              label="Action"
              width="100"
              prop="">
            <template slot-scope="scope">
              <el-button type="danger" size="small" @click="clearNotification(scope, scope.row.id)">Clear</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="infoDialogVisibility" title="General Information" top="5vh" width="800px">
      <div class="p-3">
        <el-table
            :data="generalInfoData"
            style="width: 100%">
          <el-table-column
              label="Info"
              prop="abber"
              width="180">
          </el-table-column>
          <el-table-column
              label="Description"
              prop="desc">
            <template slot-scope="scope">
              <span v-html="scope.row.desc"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </el-menu>
</template>

<script>
import {getLS, strCFL} from "devegram-javascript-util";

export default {
  components: {
    voipResellerHeader: () => import('@/modules/user-reseller-features/cpanel-header/View.vue'),
    voipCustomerHeader: () => import('@/modules/user-customer-features/cpanel-header/View.vue'),
    voipGenerateLiveUserHeader: () => import('@/modules/user-generate-live-features/cpanel-header/View.vue')
  },
  data() {
    return {
      userVOSTodayconsumption: '',
      userVOSBalance: '',
      userVOSOverdraft: '',
      newNotificationsCount: 0,
      userNotifications: [],
      isUserCustomerOrReseller: $store.getters['user-state/isUserCustomer'] || $store.getters['user-state/isUserReseller'],
      generalInfoData: [{
        abber: 'VQ',
        desc: 'Voice Quality, it usually refers to a Voice Quality test the tells,<br> and which also includes the RBT feature',
      }, {
        abber: 'RBT',
        desc: 'Ring Back Tone, it is about a test to check the ring back tone <br> when a phone is being ringing.',
      }, {
        abber: 'LCR',
        desc: 'Least Cost Route, Fasfreeroute have table that shows you <br>least cost route of the available destinations',
      }],
      notificationsDialogVisibility: false,
      infoDialogVisibility: false,
      activeIndex: '1',
      activeIndex2: '1',
      currentDomain: process.env.VUE_APP_CURRENT_DOMAIN,
      userProfileId: $store.state['user-state'].profile.profile_id,
      sideMenuRef: null,
      username: $store.state['user-state'].profile.username,
      vosServerId: $store.state['user-state'].profile.vos_server_id,
      userVosType: -1,
    };
  },
  mounted() {
    this.sideMenuRef = document.getElementById('el-aside-menu')
    this.getUserNewNotificationsCount()
    setInterval(() => {
      this.getUserNewNotificationsCount()
    }, 1000 * 15)

    if (this.isUserCustomerOrReseller) this.userVOSType = 0
    if ($store.getters['user-state/isUserGenerateLive']) this.userVOSType = 2

    if (this.isUserCustomerOrReseller || $store.getters['user-state/isUserGenerateLive']) {
      $store.dispatch('user-api/getBalanceInfo', {userVOSType: this.userVOSType, username: this.username, vosServerId: this.vosServerId}).then( r => {
        if (r) {
          this.userVOSBalance = r.money;
          this.userVOSOverdraft = r.limitmoney;
          this.userVOSTodayconsumption = r.todayconsumption
        }
      })
      setInterval(() => {
        $store.dispatch('user-api/getBalanceInfo', {userVOSType: this.userVOSType, username: this.username, vosServerId: this.vosServerId}).then( r => {
          if (r) {
            this.userVOSBalance = r.money;
            this.userVOSOverdraft = r.limitmoney;
            this.userVOSTodayconsumption = r.todayconsumption
          }
        })
      }, 1000 * 60)
    }
  },
  methods: {
    openPage (route) {
      $router.push(route)
    },
    clearAllUserNotification() {
      this.$store.dispatch('user-api/clearAllUserNotification', {user_id: $store.state['user-state'].profile.id}).then( r => {
        this.notificationsDialogVisibility = false
      })
    },
    getUserNewNotificationsCount () {
      this.$store.dispatch('user-api/getUserNewNotificationsCount', {user_id: $store.state['user-state'].profile.id}).then( r => {
        this.newNotificationsCount = r
      })
    },
    clearNotification (scope, notificationId) {
      this.userNotifications.splice(scope.$index, 1)
      this.$store.dispatch('user-api/removeNotification', {id: notificationId}).then( r => {})
    },
    getUserNotifications () {
      this.$store.dispatch('user-api/getNotifications', {user_id: $store.state['user-state'].profile.id}).then( r => {
        this.userNotifications = r
      })
    },
    tableRowClassName({row, rowIndex}) {
      if (row.seen_status == 0) {
        return 'app-bg-gold-low-alfa';
      }
      return '';
    },
    openInfoDialog() {
      this.infoDialogVisibility = true
    },
    openNotificationsDialogVisibility() {
      this.getUserNotifications();
      this.notificationsDialogVisibility = true
    },
    strCFL(s) {
      if (!s) return s;
      return strCFL(s)
    },
    getSessionData(key) {
      return getLS('user')[key]
    },
    drawerOpenToggle() {
      $store.state['app-state'].isDrawerOpen = !$store.state['app-state'].isDrawerOpen
    },
    menuOpenToggle() {
      //$store.state['app-state'].isDrawerOpen = !$store.state['app-state'].isDrawerOpen
      let w = this.sideMenuRef.style.width
      if (w === '0px') {
        this.sideMenuRef.style.width = '200px'
      } else {
        this.sideMenuRef.style.width = '0px'
      }
    },
    handleSelect(key, keyPath) {
    }
  }
}
</script>

<style lang="scss">
.esb-header {
  /*background: linear-gradient(90deg, rgba(160,117,231,1) 0%, rgba(106,44,191,1) 35%, rgba(39,33,128,1) 100%);*/
  background-color: #fff;

  .el-menu-item.is-active {
    color: #fff !important;
    background-color: #000621 !important
  }

  .el-menu-item, .el-submenu {
    /*float: right !important;*/
  }

  .el-menu-item {
    /*text-align: right !important;*/
  }

}

.el-menu--horizontal > .el-menu-item {
  height: 48px !important;
  line-height: 50px;
}

.el-menu.el-menu--horizontal {
  /*border: 1px solid #4e555b !important;*/
  height: 50px;
  /*box-shadow: 1px 0 2px rgba(50,50,50,.8);*/
}

.el-menu-item a {
  color: #fff !important;
  text-decoration: none !important;
}
</style>
